import React from 'react';
import { Tooltip } from '@uhg-abyss/web/ui/Tooltip';
import { tooltipContents } from '@src/constants';

interface MyComponentProps {
  title?: string;
  Component?: React.ElementType;
  children: React.ReactNode;
}

const TableHeader: React.FC<MyComponentProps> = ({
  Component = 'div',
  title = '',
  children,
}) => {
  const tooltip = tooltipContents[title];
  return (
    <Tooltip content={tooltip || children}>
      <Component>{children}</Component>
    </Tooltip>
  );
};

export default TableHeader;
